import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Estado } from '../../_models/estado';
import { EstadoService } from '../../_services/estado.service';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ListaService } from '../../_services/lista.service';
import { EstadosReglas } from '../../_models/estados-reglas';
import { EstadosReglasService } from '../../_services/estados-reglas.service';
import { forkJoin } from 'rxjs';

@Component( {
  selector: 'app-estados-listado',
  templateUrl: 'estados-listado.component.html',
  styleUrls: [ 'estados-listado.component.css' ]
} )

export class EstadosListadoComponent implements OnInit {

  // --- Tab Listado de estados ---
  estados: Estado[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild( 'dt', { static: true } ) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  // --- Tab Reglas ---
  columnasReglas: any[];
  reglas: EstadosReglas[] = [];
  reglasFiltradas: EstadosReglas[] = []; // Array que se renderizará en la tabla de reglas
  mostrarFormRegla = false;
  editandoRegla = false;
  cargandoReglas = true;
  reglaSeleccionada: EstadosReglas | null = null;
  formularioRegla: FormGroup;
  submittedRegla = false;
  guardandoRegla = false;

  // Variables para filtros de reglas en la tabla superior
  busquedaReglas = '';
  tiposProductoFiltrados: string[] = [];

  lisTiposProducto: SelectItem[] = [];
  lisEstadosHabilitados: SelectItem[] = [];
  lisEstadosOrigen: SelectItem[] = [];
  lisCausales: SelectItem[] = [];

  constructor(
    private estServicio: EstadoService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private lisService: ListaService,
    private reglasServicio: EstadosReglasService,
    private fb: FormBuilder,
    private conServicio: ConfirmationService
  ) {}

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/estados' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_ESTADO' ), sort: true },
      { field: 'indicadorEstadoInicial', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_ESTADOINICIAL' ), sort: true },
      { field: 'indicadorEstadoFinal', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_ESTADOFINAL' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'orden', header: this.navServicio.buscarMensaje( 'LBL_ORDEN' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.columnasReglas = [
      { field: 'tipoProducto', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_TIPOPRODUCTO' ), sort: true },
      { field: 'estadoOrigen', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_ESTADOORIGEN' ), sort: true },
      { field: 'dias', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_TIEMPOINACTIVIDAD' ), sort: true },
      { field: 'estadoDestino', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_ESTADODESTINO' ), sort: true },
      { field: 'causal', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_CAUSAL' ), sort: true },
      { field: 'plataformaDigital', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_PLATAFORMADIGITAL' ), sort: false },
      { field: 'bancaRelacional', header: this.navServicio.buscarMensaje( 'ESTADOS.LBL_BANCARELACIONAL' ), sort: false },
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.navServicio.getSearch( 'estados.component' );

    this.estServicio.listado().subscribe( estados => {
      this.estados = estados || [];
      this.ordenarEstados();
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );

      // Construir SelectItems de estados habilitados
      const estadosHabilitados = estados.filter( e => e.indicadorHabilitado );
      this.lisEstadosHabilitados = estadosHabilitados.map( e => ( { label: e.nombre, value: e.idEstado } ) );
    } );

    // Listas genéricas
    forkJoin( {
      tiposProducto: this.lisService.getMasterDetails( 'ListasTiposProductosBancarios' ),
      causales: this.lisService.getMasterDetails( 'ListasCausalesSolicitudes' )
    } ).subscribe( ( { tiposProducto, causales } ) => {
      this.lisTiposProducto = tiposProducto.map( t => ( { label: t.nombre, value: t.idLista } ) );
      this.lisCausales = causales.map( t => ( { label: t.nombre, value: t.idLista } ) );
    } );

    // Cargar reglas desde el servicio (solo habilitadas)
    this.reglasServicio.listado().subscribe( reglas => {
      this.reglas = reglas.filter( r => r.indicadorHabilitado );
      this.cargandoReglas = false;
      this.filtrarReglas();
    }, () => {
      this.cargandoReglas = false;
    } );

    this.inicializarFormulario();
  }

  // ===================== Tab Listado =====================

  crear() {
    this.router.navigate( [ 'apl/estados/agregar' ] );
  }

  ver( estado: Estado ) {
    this.router.navigate( [ 'apl/estados/detalle/' + estado.idEstado ] );
  }

  editar( estado: Estado ) {
    this.router.navigate( [ 'apl/estados/actualizar/' + estado.idEstado ] );
  }

  editarRoles( estado: Estado ) {
    this.router.navigate( [ 'apl/estados/roles/' + estado.idEstado ] );
  }

  editarBotones( estado: Estado ) {
    this.router.navigate( [ 'apl/estados/botones/' + estado.idEstado ] );
  }

  gestionarCausal( estado: Estado ) {
    this.router.navigate( [ 'apl/estados/causales/' + estado.idEstado ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'estados.component', this.busqueda );
  }

  ordenarEstados() {
    this.estados = [ ...this.estados ].sort( ( a, b ) => this.valorOrden( a ) - this.valorOrden( b ) );
  }

  esPrimero( estado: Estado ) {
    const ordenados = this.estadosOrdenados();
    return ordenados.length > 0 && ordenados[ 0 ].idEstado === estado.idEstado;
  }

  esUltimo( estado: Estado ) {
    const ordenados = this.estadosOrdenados();
    return ordenados.length > 0 && ordenados[ ordenados.length - 1 ].idEstado === estado.idEstado;
  }

  subir( estado: Estado ) {
    this.intercambiarOrden( estado, -1 );
  }

  bajar( estado: Estado ) {
    this.intercambiarOrden( estado, 1 );
  }

  private intercambiarOrden( estado: Estado, direccion: number ) {
    const ordenados = this.estadosOrdenados();
    const indice = ordenados.findIndex( item => item.idEstado === estado.idEstado );
    const destino = indice + direccion;
    if ( indice < 0 || destino < 0 || destino >= ordenados.length ) {
      return;
    }
    const actual = ordenados[ indice ];
    const vecino = ordenados[ destino ];
    const ordenActual = actual.orden;
    const ordenVecino = vecino.orden;
    this.estServicio.bulk( [
      { ...actual, orden: ordenVecino },
      { ...vecino, orden: ordenActual }
    ] ).subscribe( () => {
      actual.orden = ordenVecino;
      vecino.orden = ordenActual;
      this.ordenarEstados();
    } );
  }

  private estadosOrdenados() {
    return [ ...this.estados ].sort( ( a, b ) => this.valorOrden( a ) - this.valorOrden( b ) );
  }

  private valorOrden( estado: Estado ) {
    return estado.orden === null || estado.orden === undefined ? Number.MAX_SAFE_INTEGER : estado.orden;
  }

  // ===================== Tab Reglas =====================

  // Métodos para filtrado superior de la tabla de reglas
  filtrarReglas() {
    this.reglasFiltradas = this.reglas.filter( r => {
      // Filtrar por tipos de producto (Multiselect)
      const cumpleProducto = this.tiposProductoFiltrados.length === 0 || this.tiposProductoFiltrados.includes( r.idTipoProductoBancario );

      // Filtrar por buscador global (busquedaReglas)
      const busquedaClean = this.busquedaReglas.trim().toLowerCase();
      const cumpleBusqueda = !busquedaClean ||
        ( r.tipoProducto && r.tipoProducto.toLowerCase().includes( busquedaClean ) ) ||
        ( r.estadoOrigen && r.estadoOrigen.toLowerCase().includes( busquedaClean ) ) ||
        ( r.estadoDestino && r.estadoDestino.toLowerCase().includes( busquedaClean ) ) ||
        ( r.causalSolicitud && r.causalSolicitud.toLowerCase().includes( busquedaClean ) ) ||
        ( r.dias && r.dias.toString().includes( busquedaClean ) );

      return cumpleProducto && cumpleBusqueda;
    } );
  }

  limpiarFiltrosReglas() {
    this.tiposProductoFiltrados = [];
    this.busquedaReglas = '';
    this.filtrarReglas();
  }

  actualizarListaEstadoOrigen() {
    this.lisEstadosOrigen = this.obtenerEstadosOrigenDisponibles();
  }

  // Obtener lista dinámica de estados origen para el dropdown del formulario
  obtenerEstadosOrigenDisponibles(): SelectItem[] {
    const val = this.formularioRegla.value;
    const idTipoProductoSeleccionado = val.idTipoProductoBancario;

    return this.estados
      .filter( e => {
        // 1. Debe estar habilitado
        if ( !e.indicadorHabilitado ) return false;

        // 2. Omitir estados con indicadorEstadoFinal en true
        if ( e.indicadorEstadoFinal ) return false;

        // 3. Omitir estados origen que ya existan en la tabla del mismo tipo de producto
        const yaExisteEnTabla = this.reglas.some( r => {
          // Si estamos editando, no auto-filtrar el estado de la regla seleccionada
          if ( this.editandoRegla && this.reglaSeleccionada && r.idEstadoRegla === this.reglaSeleccionada.idEstadoRegla ) {
            return false;
          }
          return r.idTipoProductoBancario === idTipoProductoSeleccionado && r.idEstadoOrigen === e.idEstado;
        } );

        return !yaExisteEnTabla;
      } )
      .map( e => ( { label: e.nombre, value: e.idEstado } ) );
  }

  private inicializarFormulario() {
    this.formularioRegla = this.fb.group( {
      idTipoProductoBancario: [ null, Validators.required ],
      idEstadoOrigen: [ null, Validators.required ],
      dias: [ null, [ Validators.required, Validators.min( 1 ) ] ],
      idEstadoDestino: [ null, Validators.required ],
      idCausalSolicitud: [ null, Validators.required ],
      indicadorPlataformaDigital: [ false ],
      indicadorBancaRelacional: [ false ]
    } );
  }

  get fRegla() {
    return this.formularioRegla.controls;
  }

  abrirFormRegla() {
    this.editandoRegla = false;
    this.reglaSeleccionada = null;
    this.submittedRegla = false;
    this.formularioRegla.reset( { indicadorPlataformaDigital: false, indicadorBancaRelacional: false } );
    this.mostrarFormRegla = true;
    this.actualizarListaEstadoOrigen();
  }

  editarRegla( regla: EstadosReglas ) {
    this.editandoRegla = true;
    this.reglaSeleccionada = regla;
    this.submittedRegla = false;
    this.formularioRegla.patchValue( {
      idTipoProductoBancario: regla.idTipoProductoBancario,
      idEstadoOrigen: regla.idEstadoOrigen,
      dias: regla.dias,
      idEstadoDestino: regla.idEstadoDestino,
      idCausalSolicitud: regla.idCausalSolicitud,
      indicadorPlataformaDigital: regla.indicadorPlataformaDigital,
      indicadorBancaRelacional: regla.indicadorBancaRelacional
    } );
    this.mostrarFormRegla = true;
    this.actualizarListaEstadoOrigen();
  }

  cancelarFormRegla() {
    if ( this.formularioRegla.dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'confirmReglas',
        accept: () => {
          this.cerrarFormRegla();
        },
        reject: () => {}
      } );
    } else {
      this.cerrarFormRegla();
    }
  }

  private cerrarFormRegla() {
    this.mostrarFormRegla = false;
    this.editandoRegla = false;
    this.reglaSeleccionada = null;
    this.submittedRegla = false;
    this.formularioRegla.reset( { indicadorPlataformaDigital: false, indicadorBancaRelacional: false } );
    this.actualizarListaEstadoOrigen();
  }

  guardarRegla() {
    this.submittedRegla = true;
    if ( this.formularioRegla.invalid ) {
      return;
    }

    const val = this.formularioRegla.value;

    // Validación de al menos uno de los checkboxes seleccionado
    if ( !val.indicadorPlataformaDigital && !val.indicadorBancaRelacional ) {
      this.navServicio.setMesage( 0, {
        severity: 'error',
        summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'ESTADOS.MSG_DEBEESCOGERUNINDICADOR' )
      } );
      return;
    }

    this.guardandoRegla = true;

    if ( this.editandoRegla && this.reglaSeleccionada ) {
      const reglaActualizar: EstadosReglas = {
        ...this.reglaSeleccionada,
        idTipoProductoBancario: val.idTipoProductoBancario,
        idEstadoOrigen: val.idEstadoOrigen,
        dias: val.dias,
        idEstadoDestino: val.idEstadoDestino,
        idCausalSolicitud: val.idCausalSolicitud,
        indicadorPlataformaDigital: val.indicadorPlataformaDigital,
        indicadorBancaRelacional: val.indicadorBancaRelacional
      };
      this.reglasServicio.actualizar( reglaActualizar ).subscribe( () => {
        this.recargarReglas();
        this.guardandoRegla = false;
        this.navServicio.setMesage( 0, {
          severity: 'success',
          summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'MSG_EXITOSERVICIO' )
        } );
        this.cerrarFormRegla();
      }, () => {
        this.guardandoRegla = false;
      } );
    } else {
      // Buscar si existe un registro inhabilitado con el mismo tipo producto + estado origen
      this.reglasServicio.listado().subscribe( todasLasReglas => {
        const reglaInhabilitada = todasLasReglas.find( r =>
          !r.indicadorHabilitado &&
          r.idTipoProductoBancario === val.idTipoProductoBancario &&
          r.idEstadoOrigen === val.idEstadoOrigen
        );

        if ( reglaInhabilitada ) {
          // Reutilizar el registro existente rehabilitándolo
          const reglaReactivar: EstadosReglas = {
            ...reglaInhabilitada,
            dias: val.dias,
            idEstadoDestino: val.idEstadoDestino,
            idCausalSolicitud: val.idCausalSolicitud,
            indicadorPlataformaDigital: val.indicadorPlataformaDigital,
            indicadorBancaRelacional: val.indicadorBancaRelacional,
            indicadorHabilitado: true
          };
          this.reglasServicio.actualizar( reglaReactivar ).subscribe( () => {
            this.recargarReglas();
            this.guardandoRegla = false;
            this.navServicio.setMesage( 0, {
              severity: 'success',
              summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'MSG_EXITOSERVICIO' )
            } );
            this.cerrarFormRegla();
          }, () => {
            this.guardandoRegla = false;
          } );
        } else {
          // Crear un registro nuevo
          const reglaCrear: EstadosReglas = {
            idTipoProductoBancario: val.idTipoProductoBancario,
            idEstadoOrigen: val.idEstadoOrigen,
            dias: val.dias,
            idEstadoDestino: val.idEstadoDestino,
            idCausalSolicitud: val.idCausalSolicitud,
            indicadorPlataformaDigital: val.indicadorPlataformaDigital,
            indicadorBancaRelacional: val.indicadorBancaRelacional,
            indicadorHabilitado: true
          };
          this.reglasServicio.crear( reglaCrear ).subscribe( () => {
            this.recargarReglas();
            this.guardandoRegla = false;
            this.navServicio.setMesage( 0, {
              severity: 'success',
              summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'MSG_EXITOSERVICIO' )
            } );
            this.cerrarFormRegla();
          }, () => {
            this.guardandoRegla = false;
          } );
        }
      }, () => {
        this.guardandoRegla = false;
      } );
    }
  }

  private recargarReglas() {
    this.reglasServicio.listado().subscribe( reglas => {
      this.reglas = reglas.filter( r => r.indicadorHabilitado );
      this.filtrarReglas();
    } );
  }

  validarCausal() {
    if (this.editandoRegla) {
      this.fRegla.idCausalSolicitud.setValue(null);
    }
  }

  eliminarRegla( regla: EstadosReglas ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'confirmReglas',
      accept: () => {
        const reglaInhabilitar: EstadosReglas = { ...regla, indicadorHabilitado: false };
        this.reglasServicio.actualizar( reglaInhabilitar ).subscribe( () => {
          this.recargarReglas();
          this.navServicio.setMesage( 2 );
        } );
      },
      reject: () => {}
    } );
  }
}
